import { IOrderResponse } from '../../../libraries/interfaces/tracker.interfaces'
import { chunk } from '../../../libraries/utils'
import { useTranslation } from 'react-i18next'

const PackageInformationTable = ({ orderResponse }: { orderResponse: IOrderResponse }) => {
  const { t } = useTranslation('packages')
  const information = transformInformation(orderResponse)
  const chunks = chunk(information, 2)

  return (
    <table className="table table-sm table-bordered text-muted">
      <tbody>
        {chunks.map((subChunk, index) => (
          <tr key={index}>
            {subChunk.map((tuple, index2) => (
              <td key={index2} className="w-50">
                {/* @ts-ignore */}
                <strong>{t(`order.metadata.${tuple[0]}`)}:</strong> {tuple[1]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

function transformInformation(orderResponse: IOrderResponse): [string, string][] {
  let arrayWithKeyValues = []

  for (const key in orderResponse.order.information) {
    arrayWithKeyValues.push([key, orderResponse.order.information[key]])
  }

  if (orderResponse.order.next && orderResponse.order.next.length > 0) {
    arrayWithKeyValues.push(['Next ID', orderResponse.order.next.join(', ')])
  }

  return arrayWithKeyValues
}

export default PackageInformationTable
